import styles from './admin-licenses-grid.module.scss';
import { booleanHeader, CreateHeaders, dateHeader, HeaderSizeEnum, textHeader } from '@frontend-workspace/react-shared-lib';
import { ILicenses } from '../../_models/licenses';
import { DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import { useTableConfigHook } from '../../requestUtils';
import WebkuaTable from '../../webkua-table/webkua-table';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface LicensesGridProps {
  licenses: ILicenses[],
  setIsTerminationDate: boolean,
  onDateChange: (dateRange: DateRange<Date> | null) => void,
  onChange: (checked: boolean) => void
}

export function LicensesGrid(props: LicensesGridProps) {
  const { t } = useTranslation();
  const tableConfig = useTableConfigHook("adminLicenses");

  const headers = CreateHeaders([
    textHeader("licenseNumber", t("standard.licenseNumber"), HeaderSizeEnum.MEDIUM),
    textHeader("productName", t("standard.name"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("vismaContractItemId", "Visma ID", HeaderSizeEnum.MEDIUM),
    dateHeader("createdDate", t("standard.startDate")),
    dateHeader("expirationDate", t("standard.expirationDate")),
    dateHeader("terminationDate", t("standard.terminationDate")),
    textHeader("recurringDiscountPercent", t("standard.discountPercent"), HeaderSizeEnum.MEDIUM, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    textHeader("contractNumber", t("standard.contractNo"), HeaderSizeEnum.MEDIUM),
    textHeader("companyNumber", t("standard.companyNumber"), HeaderSizeEnum.MEDIUM),
    textHeader("customerName", t("standard.customerName"), HeaderSizeEnum.EXTRA_LARGE),
    booleanHeader("isSchoolversion", t("standard.academicVersion")),
    booleanHeader("isSlm", "SLM")
  ])

  return (
    <WebkuaTable
      headers={headers}
      tableFilters={[
        {
          label: t("standard.showOnlyTerminationDate"),
          checked: props.setIsTerminationDate,
          onChange: props.onChange
        }
      ]}
      data={props.licenses}
      tableConfig={tableConfig}
      onSetDateRange={props.onDateChange}
    />
  );
}

export default LicensesGrid;